export const numberFormatter = (value: string | number | undefined): string => {
  if (!value) return ''
  if (String(value).includes('.')) {
    const [integer, decimal] = String(value).split('.')
    return `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimal}`
  }
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
